var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectCustom',{staticClass:"select",attrs:{"label":_vm.locale,"options":_vm.options},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})}
var staticRenderFns = []

export { render, staticRenderFns }